// src/services/agentApi.ts — Agent related API endpoints
import { apiClient } from './apiClient';

export const agentApi = {
    // Agent CRUD
    deployAgent: (data: any): Promise<any> => apiClient._agentPost('/v1/agents/deploy', data),
    listAgents: (): Promise<any> => apiClient._agentGet('/v1/agents'),
    getAgentStatus: (id: number): Promise<any> => apiClient._agentGet(`/v1/agents/${id}/status`),
    getAgentLogs: (id: number, tail: number = 100): Promise<any> => apiClient._agentGet(`/v1/agents/${id}/logs?tail=${tail}`),
    getAgentRuns: (id: number, limit: number = 50, offset: number = 0): Promise<any> =>
        apiClient._agentGet(`/v1/agents/${id}/runs?limit=${limit}&offset=${offset}`),
    triggerAgent: (id: number, input: any = {}, runtimeTier?: string): Promise<any> =>
        apiClient._agentPost(`/v1/agents/${id}/trigger`, { input, runtimeTier }),
    deleteAgent: (id: number): Promise<any> => apiClient._agentDel(`/v1/agents/${id}`),

    // Task operations
    getTaskResult: (taskId: number): Promise<any> => apiClient._agentGet(`/v1/agents/tasks/${taskId}/result`),
    cancelTask: (taskId: number): Promise<any> => apiClient._agentPost(`/v1/agents/tasks/${taskId}/cancel`),

    // Dead-letter queue
    getDeadLetterTasks: (limit: number = 50): Promise<any> => apiClient._agentGet(`/v1/agents/dead-letter?limit=${limit}`),
    retryDeadLetterTask: (taskId: number): Promise<any> => apiClient._agentPost(`/v1/agents/dead-letter/${taskId}/retry`),
    purgeDeadLetterTasks: (): Promise<any> => apiClient._agentDel('/v1/agents/dead-letter'),

    // Performance
    getAgentPerformance: (id: number, days: number = 30): Promise<any> => apiClient._agentGet(`/v1/agents/${id}/performance?days=${days}`),
    getAgentPerformanceSummary: (id: number): Promise<any> => apiClient._agentGet(`/v1/agents/${id}/performance/summary`),

    // Queue & config
    getQueueStats: (): Promise<any> => apiClient._agentGet('/v1/agents/queue/stats'),
    getRuntimeTiers: (): Promise<any> => apiClient._agentGet('/v1/agents/runtime-tiers'),
    getSchedulePresets: (): Promise<any> => apiClient._agentGet('/v1/agents/schedule/presets'),

    // Templates
    getTemplates: (params: any = {}): Promise<any> => {
        const query = new URLSearchParams(params).toString();
        return apiClient._agentGet(`/v1/templates?${query}`);
    },
    getTemplateCategories: (): Promise<any> => apiClient._agentGet('/v1/templates/categories'),
    getTemplateDetail: (slug: string): Promise<any> => apiClient._agentGet(`/v1/templates/${slug}`),

    // Webhooks
    enableWebhook: (id: number): Promise<any> => apiClient._agentPost(`/v1/agents/${id}/webhook`),
    getWebhookInfo: (id: number): Promise<any> => apiClient._agentGet(`/v1/agents/${id}/webhook`),
    disableWebhook: (id: number): Promise<any> => apiClient._agentDel(`/v1/agents/${id}/webhook`),

    // Usage (for usage meter)
    getAgentUsage: (): Promise<any> => apiClient._agentGet('/v1/agents/queue/stats')
};
